<template>
  <div class="dark-mode-switch-container">
    <div class="dark-mode-switch notexpanded" @click="toggleDarkMode">
      <span class="switch-icon ">
        <span class="material-icons " v-if="isDarkMode">dark_mode</span>
        <span class="material-icons" v-if="!isDarkMode">light_mode</span>
      </span>
    </div>
    <div class="dark-mode-switch expanded" @click="toggleDarkMode">
      <span class="switch-icon sun" :class="{ active: !isDarkMode }">
        <i class="material-icons">light_mode</i>
      </span>
      <span class="switch-track" :class="{ dark: isDarkMode }">
        <span class="switch-thumb" :class="{ dark: isDarkMode }"></span>
      </span>
      <span class="switch-icon moon" :class="{ active: isDarkMode }">
        <i class="material-icons">dark_mode</i>
      </span>
    </div>
    <!-- Controles extra a la derecha del switch (p. ej. zoom). -->
    <slot></slot>
  </div>
</template>

<script>
import { wencesApi } from "@/api/wencesApi";

export default {
  name: "DarkModeSwitch",
  data() {
    return {
      isDarkMode: false
    };
  },
  mounted() {
    this.loadDarkModePreference();
  },
  methods: {
    async loadDarkModePreference() {
      // Default: clear mode when user has no explicit preference.
      this.isDarkMode = false;

      const token = localStorage.getItem("token");
      const userId = localStorage.getItem("userId");
      if (!token || !userId) {
        this.applyDarkMode();
        return;
      }

      try {
        const response = await wencesApi.get("/api/users/myprofile");
        if (response?.data?.ok && response?.data?.data) {
          this.isDarkMode = response.data.data.darkMode === true;
        }
      } catch (error) {
        console.error("Error loading dark mode preference:", error);
      }

      this.applyDarkMode();
    },
    async toggleDarkMode() {
      const previousMode = this.isDarkMode;
      this.isDarkMode = !this.isDarkMode;
      this.applyDarkMode();

      const userId = localStorage.getItem("userId");
      if (!userId) return;

      try {
        await wencesApi.post("/api/users/edit", {
          user: {
            _id: userId,
            darkMode: this.isDarkMode,
          },
        });
      } catch (error) {
        // Revert UI if server update fails.
        this.isDarkMode = previousMode;
        this.applyDarkMode();
        console.error("Error saving dark mode preference:", error);
      }
    },
    applyDarkMode() {
      if (this.isDarkMode) {
        document.documentElement.id = "darkdesign";
      } else {
        document.documentElement.removeAttribute("id");
      }
    }
  }
};
</script>

<style scoped>
.dark-mode-switch-container {
  padding: 15px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-top: 1px solid rgba(180, 180, 180, 0.3);
  margin-top: auto;
  transition: all 0.3s ease;
}

.dark-mode-switch {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 25px;
  background: rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.dark-mode-switch:hover {
  background: rgba(255, 255, 255, 0.2);
}

.switch-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.switch-icon i {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.4);
  transition: all 0.3s ease;
}

.switch-icon.active i {
  color: #ffc107;
}

.switch-icon.moon.active i {
  color: #7c9ed9;
}

.switch-track {
  position: relative;
  width: 36px;
  height: 18px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  transition: all 0.3s ease;
}

.switch-track.dark {
  background: rgba(124, 158, 217, 0.4);
}

.switch-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  background: #ffc107;
  border-radius: 50%;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.switch-thumb.dark {
  left: 20px;
  background: #7c9ed9;
}

/* Dark mode specific styles */
#darkdesign .dark-mode-switch {
  background: rgba(255, 255, 255, 0.05);
}

#darkdesign .dark-mode-switch:hover {
  background: rgba(255, 255, 255, 0.1);
}

#darkdesign .dark-mode-switch-container {
  border-top-color: var(--dark-border-color, #2f3943);
}

/* Sidebar mini state - hide text and show only icons */
.sidebar-mini .dark-mode-switch-container {
  padding: 15px 5px;
}

/* Sidebar colapsado: los íconos no entran en fila, se apilan */
.sidebar:not(.sidebar-expanded) .dark-mode-switch-container {
  flex-direction: column;
}

.sidebar-mini .switch-track,
.sidebar-mini .switch-icon.sun {
  display: none;
}

.sidebar-mini .dark-mode-switch {
  padding: 8px;
  gap: 0;
}

.sidebar-mini .switch-icon.moon i {
  font-size: 22px;
  color: rgba(255, 255, 255, 0.6);
}

.sidebar-mini .switch-icon.moon.active i {
  color: #7c9ed9;
}

/* Show full switch when sidebar is expanded */
.sidebar-mini.sidebar-expanded .switch-track,
.sidebar-mini.sidebar-expanded .switch-icon.sun {
  display: flex;
}

.sidebar-mini.sidebar-expanded .dark-mode-switch {
  padding: 6px 10px;
  gap: 8px;
}

.sidebar-mini.sidebar-expanded .switch-icon.moon i {
  font-size: 18px;
}
</style>

